<div class="h-full flex flex-column">
  <!-- Header principal que ocupa todo el ancho del modal -->
  <div
    class="px-4 py-2 md:py-3 border-bottom-1 surface-border bg-gradient-to-r from-primary-50 to-primary-100 flex-shrink-0"
  >
    <div class="flex align-items-center gap-3">
      <div
        class="hidden md:flex h-2rem w-2rem border-round align-items-center justify-content-center shadow-2 avatar-gradient-primary"
      >
        <i class="pi pi-search text-white md:text-lg text-lg"></i>
      </div>
      <div class="flex-grow-1">
        <p class="m-0 mt-1 text-sm md:text-sm text-xs text-600 font-medium">
          Agregando productos a la lista
          <span class="font-semibold text-primary">"{{ lista.name }}"</span>
        </p>
      </div>
    </div>
  </div>

  <!-- Content del modal con padding responsivo -->
  <div class="flex-1 overflow-hidden p-4 md:p-4 p-3 flex flex-column">
    <div class="mb-3 md:mb-3 mb-2">
      <label
        class="block text-sm md:text-sm text-xs font-medium text-900 mb-2"
      >
        Buscar y seleccionar productos
      </label>
      <app-producto-select-busqueda
        #search
        [multiple]="false"
        [placeholder]="'Busque productos por nombre o SKU...'"
        [nuevosArticulos]="selectedProducts"
        (articulosSeleccionados)="onFiltrosCambiados($event)"
      ></app-producto-select-busqueda>
    </div>

    <!-- Lista de productos seleccionados con contenedor - usar todo el espacio restante -->
    <div
      class="surface-card border-round-lg overflow-hidden shadow-1 border-1 border-200 flex flex-column flex-1"
    >
      <!-- Header mejorado y más atractivo -->
      @if (selectedProducts.length) {
      <div
        class="md:p-4 px-3 py-2 border-bottom-1 surface-border bg-gradient-to-r from-green-50 to-blue-50 flex-shrink-0"
      >
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-3 md:gap-3 gap-2">
            <div>
              <h3
                class="hidden md:block m-0 font-bold text-lg md:text-lg text-base text-900"
              >
                Productos seleccionados
              </h3>
              <h3
                class="block md:hidden m-0 font-bold text-lg md:text-lg text-base text-900"
              >
                Productos
              </h3>
              <p
                class="hidden md:block mt-1 text-xs md:text-sm text-600 font-medium"
              >
                {{ selectedProducts.length }}
                {{
                  selectedProducts.length === 1
                    ? 'producto listo'
                    : 'productos listos'
                }}
                para agregar a la lista
              </p>
            </div>
          </div>
          <div class="flex align-items-center gap-2">
            <p-button
              label="Limpiar"
              [label]="
                'Limpiar todo' | slice : 0 : (innerWidth > 768 ? 12 : 7)
              "
              icon="pi pi-times"
              styleClass="p-button-text p-button-sm md:p-button-text"
              (click)="clearAllProducts()"
            >
            </p-button>
          </div>
        </div>
      </div>
      }

      <!-- Lista de productos optimizada - usar todo el espacio disponible -->
      <div class="flex-1 position-relative" style="min-height: 0">
        <p-scrollPanel
          [style]="{ width: '100%', height: '100%' }"
          styleClass="surface-card"
        >
          <!-- Productos reales -->
          @if (selectedProducts.length && !isLoading) {
          <div>
            @for ( item of selectedProducts; track $index; let isLast = $last)
            {
            <div
              class="px-4 py-3 md:px-4 md:py-3 px-3 py-2 transition-all transition-duration-150 border-bottom-1 surface-border hover:surface-hover"
              [class.border-bottom-none]="isLast"
            >
              <div class="flex align-items-center gap-4 md:gap-4 gap-3 w-full">
                <!-- Imagen del producto -->
                <div class="flex-shrink-0">
                  @if (item.image) {
                  <img
                    [src]="item.image"
                    [alt]="item.name"
                    class="border-round border-1 border-300"
                    [ngStyle]="{
                      width: innerWidth > 768 ? '50px' : '40px',
                      height: innerWidth > 768 ? '50px' : '40px',
                      'object-fit': 'cover'
                    }"
                  />
                  } @if (!item.image) {
                  <div
                    class="border-round bg-gray-100 flex align-items-center justify-content-center border-1 border-300"
                    [ngStyle]="{
                      width: innerWidth > 768 ? '3rem' : '2.5rem',
                      height: innerWidth > 768 ? '3rem' : '2.5rem'
                    }"
                  >
                    <i
                      class="pi pi-image text-gray-400"
                      [ngClass]="innerWidth > 768 ? 'text-sm' : 'text-xs'"
                    ></i>
                  </div>
                  }
                </div>
                <!-- Información del producto - ocupa todo el espacio disponible -->
                <div class="flex-grow-1 min-w-0">
                  <p
                    class="m-0 font-medium line-height-3 text-900"
                    [ngClass]="innerWidth > 768 ? 'text-sm' : 'text-xs'"
                    style="
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.name | titlecase }}
                  </p>
                  <p
                    class="m-0 mt-1 product-sku text-color-secondary"
                    [ngClass]="innerWidth > 768 ? 'text-xs' : 'text-xs'"
                  >
                    {{ item.sku }}
                  </p>
                </div>
                <!-- Acciones -->
                <div class="flex gap-2 md:gap-2 gap-1 flex-shrink-0">
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    pTooltip="Quitar de la lista"
                    tooltipPosition="left"
                    [styleClass]="
                      'p-button-rounded ' +
                      (innerWidth > 768 ? '' : 'p-button-sm')
                    "
                    (click)="unselectProduct($index)"
                  >
                  </p-button>
                </div>
              </div>
            </div>
            }
          </div>
          }

          <!-- Empty state simplificado -->
          @if (!selectedProducts.length && !isLoading) {
          <div
            class="flex flex-column align-items-center justify-content-center text-center px-4 py-8 md:px-4 md:py-8 px-3 py-6"
            [ngStyle]="{ 'min-height': innerWidth > 768 ? '200px' : '150px' }"
          >
            <!-- Icono simple -->
            <div class="mb-4 md:mb-4 mb-3">
              <i
                class="text-400 opacity-60"
                [ngClass]="
                  innerWidth > 768
                    ? 'pi pi-inbox text-6xl'
                    : 'pi pi-inbox text-4xl'
                "
              ></i>
            </div>
            <!-- Texto simple -->
            <h3
              class="font-semibold text-900 mb-2"
              [ngClass]="innerWidth > 768 ? 'text-xl' : 'text-lg'"
            >
              Sin productos seleccionados
            </h3>
            <p
              class="text-600 m-0"
              [ngClass]="innerWidth > 768 ? 'text-sm' : 'text-xs'"
            >
              Use el buscador de arriba para encontrar y seleccionar productos
              para
              <span class="font-semibold text-primary"
                >"{{ lista.name }}"</span
              >
            </p>
          </div>
          }

          <!-- Loading compacto -->
          @if (isLoading) {
          <div class="p-4 md:p-4 p-3 text-center">
            <p-progressSpinner
              strokeWidth="4"
              [style]="{
                width: innerWidth > 768 ? '40px' : '30px',
                height: innerWidth > 768 ? '40px' : '30px'
              }"
            />
            <p
              class="text-600 mt-2 m-0"
              [ngClass]="innerWidth > 768 ? 'text-sm' : 'text-xs'"
            >
              Agregando productos...
            </p>
          </div>
          }
        </p-scrollPanel>
      </div>
    </div>
  </div>

  <!-- Footer simplificado con padding responsivo -->
  <div
    class="border-top-1 surface-border bg-white p-4 md:p-4 p-3 flex-shrink-0"
  >
    <div class="flex justify-content-end align-items-center gap-3 md:gap-0">
      <!-- Botones responsivos -->
      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          [label]="innerWidth > 768 ? 'Cancelar' : 'Cancelar'"
          icon="pi pi-times"
          [styleClass]="
            'p-button-text p-button-secondary ' +
            (innerWidth > 768 ? '' : 'p-button-sm')
          "
          (click)="close(false)"
          [disabled]="isLoading"
        >
        </p-button>

        <p-button
          [label]="
            selectedProducts.length > 0
              ? innerWidth > 768
                ? 'Agregar a Lista (' + selectedProducts.length + ')'
                : 'Agregar (' + selectedProducts.length + ')'
              : innerWidth > 768
              ? 'Agregar a Lista'
              : 'Agregar'
          "
          icon="pi pi-plus"
          [styleClass]="
            'font-medium ' + (innerWidth > 768 ? '' : 'p-button-sm')
          "
          [disabled]="selectedProducts.length === 0"
          [loading]="isLoading"
          (click)="guardar()"
        >
        </p-button>
      </div>
    </div>
  </div>
</div>
